import React from 'react'
import {Button} from "antd";
import { navigate } from '@reach/router';

const ClosePurchase = ({record}) => {
    const handleCompleteClick = () =>  {
        navigate(`purchase/complete/${record.id}`)
    }

    return(
        <React.Fragment>
            <Button
                onClick={handleCompleteClick}
                type={'link'}
                disabled={record.completedPurchase}
            >
                Tamamla
            </Button>
        </React.Fragment>
    )
}
export default ClosePurchase